import { SxProps, Theme, Typography } from '@mui/material'

export interface PageTextProps {
  children: React.ReactNode
  sx?: SxProps<Theme>
}

/**
 * Display a number (W) as kilo watts (kW) or emdash if no number.
 */
export const PageText = (props: PageTextProps): JSX.Element => {

  return (
    <Typography variant="body1" sx={{
      ...props.sx
    }}>
      {props.children}
    </Typography>
  )
}
